import React from "react";
import { formatDuration } from "../utils/formatDuration";

function formatTime(isoString) {
  return new Date(isoString).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
}

function ServerSessionBlock({ session }) {
  const requestCount = session.requestCount;
  const duration = formatDuration(session.durationMs);

  return (
    <div className="session-block">
      <div className="session-header">
        <span className="session-meta">
          {new Date(session.start).toLocaleDateString()}
        </span>
        <span className="session-sub">
          {formatTime(session.start)} – {formatTime(session.end)}
          &nbsp;·&nbsp;{duration === "—" ? "< 1s" : `≥ ${duration}`}
          &nbsp;·&nbsp;{requestCount} request{requestCount !== 1 ? "s" : ""}
        </span>
      </div>
    </div>
  );
}

export default function ServerSessionTimeline({ sessions }) {
  if (!sessions || sessions.length === 0) {
    return <p className="text-muted">No sessions found for this period.</p>;
  }

  return (
    <div>
      {sessions.map((session) => (
        <ServerSessionBlock key={session.sessionId} session={session} />
      ))}
    </div>
  );
}
